import { render, staticRenderFns } from "./page-unsubscribe.vue?vue&type=template&id=3b601a9d"
import script from "./page-unsubscribe.vue?vue&type=script&lang=js"
export * from "./page-unsubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports